import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerGroupReportHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {onCustomerGroupDateChange, onCustomerTypeDateChange} = useContext(CustomerReportContext)

  return (
    <div className='d-flex flex-wrap justify-content-end align-items-center mb-10'>
      <PredefinedDateRange
        cb={(startDate: any, endDate: any) => {
          onCustomerGroupDateChange(startDate, endDate)
          onCustomerTypeDateChange(startDate, endDate)
        }}
        defaultValue={dateRangeLabel || 'Last 90 Days'}
        includeCurrantDay={true}
        startDate={MIN_DATE_RANGE}
      />
    </div>
  )
}
export default CustomerGroupReportHeader
